import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { EXPENSE_TRACKER } from '@constants/routes';

const ExpenseTrackerDashboard = lazy(
  () =>
    import(
      '@features/expense-tracker/pages/expense-tracker/ExpenseTrackerDashboard'
    )
);

const ExpenseTrackerList = lazy(
  () =>
    import('@features/expense-tracker/pages/expense-tracker/ExpenseTrackerList')
);

export const ExpenseTrackerRoutes: RouteObject[] = [
  {
    path: EXPENSE_TRACKER.EXPENSE_DASHBOARD,
    element: <ExpenseTrackerDashboard />
  },
  {
    path: EXPENSE_TRACKER.EXPENSE_LIST,
    element: <ExpenseTrackerList />
  }
];

export default ExpenseTrackerRoutes;
